import { useState } from 'react'
import Box from '@material-ui/core/Box'
import { useForm } from 'react-hook-form'
import { IUser } from '../../types/users'
import { AuthStyles } from './auth.module'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import CapturePassword from './CapturePassword'
import Copyright from '../../components/Copyright'
import Container from '@material-ui/core/Container'
import { IFormChangePassword } from '../../types/forms'
import { useSession } from '../../context/SessionContext'
import { JustiInputText } from '../../components/InputText'
import Alert, { ActionsOptType } from '../../components/Alert'
import RecoveryPasswordEmailDialog from './RecoveryPasswordEmailDialog'

/**
 * This method is used to recoveryPassword
 * @return {RecoveryPassword}
 */
const RecoveryPassword = (): JSX.Element => {
  const classes = AuthStyles()
  const [openCapturePassword, setOpenCapturePassword] = useState(false)
  const [openRecoveryPasswordEmail, setOpenRecoveryPasswordEmail] = useState(false)
  const [user, setUser] = useState<IUser>()
  const { control, handleSubmit, errors } = useForm<IFormChangePassword>()
  const { changePasswordValidator, changePasswordFirebase} = useSession()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  /**
   * This method is used to validate RecoveryPassword
   * @param {String} dataUser 
   */
  const onSubmit = async ({ dataUser }: IFormChangePassword) => {
    let currentUser: IUser | undefined;
    if (changePasswordValidator) 
    {
      currentUser = await changePasswordValidator(dataUser);
      if(currentUser && dataUser)
      {
        setUser(currentUser)
        if(changePasswordFirebase && currentUser.login_provider !== 'PASSPORT')
        {
          changePasswordFirebase(dataUser)
          /* setAlertOptions({
            message: 'Se envió un link para el cambio de contraseña a tu correo electrónico, por favor sigue los pasos allí indicados.',
            open: true,
            type: 'info',
          }) */
          openRecoveryPasswordEmailDialog();
        }
        else
        {
          openCapturePasswordDialog();
        }
      }
      else
      {
        setAlertOptions({
          message: 'No se encontró ningún usuario, por favor ingrese información válida.',
          open: true,
          type: 'error',
        })
      }
    }
  }

  /**
   * This method is used to open openRecoveryPasswordEmail
   * @Return {void}
  */
  const openRecoveryPasswordEmailDialog = () => {
    setOpenRecoveryPasswordEmail(true)
  }

  /**
   * This method is used to open openCapturePassword
   * @Return {void}
  */
  const openCapturePasswordDialog = () => {
    setOpenCapturePassword(true)
  }

  return (
    <>
      <CapturePassword
        open={openCapturePassword}
        user={user}
        /* username={username} */
        setOpen={setOpenCapturePassword}
      />
      <RecoveryPasswordEmailDialog
        open={openRecoveryPasswordEmail}
        setOpen={setOpenRecoveryPasswordEmail}
      />
      <Container
        component="main"
        maxWidth="xs"
        style={{ height: '100vh', display: 'flex' }}
      >
        <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
        <div className={classes.paper}>
          <Avatar 
            alt="JustiExpress"
            src="/logo.png"
            className={classes.JustiLogo}
          />
          <form
            className={classes.form}
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <h3>Recuperar contraseña</h3>
            <p>Por favor ingrese un correo electrónico o nombre de usuario válido.</p>
            <JustiInputText
              name={'dataUser'}
              copy={'Correo / Nombre de usuario'}
              errorMessage={'Usuario inválido'}
              errors={errors}
              control={control}
              autoFocus={true}
            /> 
            <Button
              style={{ marginTop: '2.5vh' }}
              type="submit"
              disabled={Object.keys(errors).length > 0}
              fullWidth
              variant="contained"
              className={classes.submit}
              /* onClick={recoverPassword} */
            >
              Restaurar
            </Button>
          </form>
          <Box mt={4} style={{ marginTop: '3.5vh' }}>
            <Copyright />
          </Box>
        </div>
      </Container>
    </>
  )
}

export default RecoveryPassword